import React from 'react';
import { FileCodeIcon, PlusIcon } from 'lucide-react';
interface PromptsViewProps {
  userPlan: string;
}
export function PromptsView({
  userPlan
}: PromptsViewProps) {
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-330">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-331">
        <div data-id="element-332">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-333">Prompt Library</h2>
          <p className="text-sm text-gray-600 mt-1" data-id="element-334">
            Manage and organize your AI prompts
          </p>
        </div>
        <button disabled={userPlan === 'Free'} className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-335">
          <PlusIcon className="w-4 h-4" data-id="element-336" />
          New Prompt
        </button>
      </div>
      {/* Content placeholder */}
      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center" data-id="element-337">
        <FileCodeIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-338" />
        <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-339">
          Prompt Management
        </h3>
        <p className="text-sm text-gray-600 max-w-md mx-auto" data-id="element-340">
          {userPlan === 'Free' ? 'This is a read-only demo. Upgrade to create and manage prompts.' : 'Create, organize, and optimize your AI prompts for better results.'}
        </p>
      </div>
    </div>;
}